document.addEventListener("DOMContentLoaded", function() {
  // Tabs
  const tabBtns = document.querySelectorAll(".faq-tab-btn");
  const panels = document.querySelectorAll(".faq-panel");
  tabBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      tabBtns.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      panels.forEach(p => p.classList.remove("active"));
      document.querySelector("#faq-" + btn.dataset.tab).classList.add("active");
    });
  });

  // Accordion
  document.querySelectorAll(".faq-panel").forEach(panel => {
    panel.querySelectorAll(".faq-question").forEach(q => {
      q.addEventListener("click", () => {
        const item = q.parentElement;
        panel.querySelectorAll(".faq-item").forEach(i => {
          if (i !== item) i.classList.remove("open");
        });
        item.classList.toggle("open");
      });
    });
  });

  // ✅ Open first Router FAQ by default
//   const firstRouterFaq = document.querySelector("#faq-router .faq-item");
//   if (firstRouterFaq) {
//     firstRouterFaq.classList.add("open");
//   }
});